export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-calender-header-1.0.0',
    name: 'JDSDatepickerCalendarHeader'
  },
  hierarchy: {
    container: ['jds-text']
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      width: '{d_3}',
      show: true
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_21}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'text-align': 'center',
      flex: 1
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'days',
          object: {
            letter: 'string'
          }
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'days.letter'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'presentation'
          },
          'aria-label': '_weekDayAriaLabel'
        }
      }
    }
  }
};
